import React from 'react';
import {
  Box,
  Button,
  Stack,
} from '@mui/material';
import { observer } from 'mobx-react';
import { DiscountsStore } from '@gamiphy/loyalty-station-desktop/store/discounts';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { DiscountSources } from '@gamiphy/bl/cashbackDiscount';
import { Trans } from '@gamiphy/react-i18n';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import CashbackPercentage from './CashbackPercentage';
import DiscountDetails from './DiscountDetails';

const CashbackDetails: React.FC = () => {
  const isNotCashbackDiscount = React.useMemo(
    () => DiscountsStore.bestFitDiscount?.applicableDiscount.discount?.source === DiscountSources.WelcomeGift ||
  DiscountsStore.bestFitDiscount?.applicableDiscount.discount?.source === DiscountSources.Campaign,
    [DiscountsStore.bestFitDiscount],
  );

  const content = React.useMemo(() => {
    if (!DiscountsStore.bestFitDiscount?.applicableDiscount.discount || isNotCashbackDiscount) {
      return <CashbackPercentage />;
    }
    return <DiscountDetails discount={DiscountsStore.bestFitDiscount.applicableDiscount.discount} />;
  }, [
    DiscountsStore.bestFitDiscount,
    isNotCashbackDiscount,
  ]);

  return (
    <Box p={1.5} sx={{ border: (th) => `1px solid ${th.palette.primary.main}` }} borderRadius="10px" bgcolor="#fff">
      <Stack spacing={1}>
        {content}
        {!UserStore.user?.phone && ThemeStore.theme.enableSmsFlow && (
          <Button
            variant="contained"
            onClick={() => UiStore.openSignupPopup()}
            sx={{
              textTransform: 'capitalize',
              justifyContent: 'space-between',
            }}
            endIcon={<KeyboardArrowRightIcon />}
          >
            <Trans
              i18nKey="shared.login"
              defaults="Login"
            />
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default observer(CashbackDetails);
